import { useMemo } from "react";
import apiInstance from "../../helpers/apiInstance";

function useUser() {
  const basePath = useMemo(() => {
    return `/user`;
  }, []);

  return {
    getProfile: () => apiInstance.get(basePath + "/profile"),
    updateUser: (payload) => apiInstance.put(basePath, payload),
    getOrgPermission: (organizationId) => {
      return apiInstance.get(
        basePath + `/organization-permission/${organizationId}`
      );
    },
    getPagePermissions: (organizationId) => {
      return apiInstance.get(basePath + `/page-permissions/${organizationId}`);
    },
  };
}

export default useUser;
